'use client'

import { StoryblokComponent, storyblokEditable, type SbBlokData } from '@storyblok/react'
import { xStack, yStack } from 'ui/src/patterns/stack'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { ProductItemSkeleton } from '@/components/ProductItemSkeleton/ProductItemSkeleton'
import { Skeleton } from '@/components/Skeleton/Skeleton'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'

type Props = SbBaseBlockProps<{
  checkoutPageContent: Array<SbBlokData>
}>

export function WidgetFlowBlock({ blok }: Props) {
  return (
    <GridLayout.Root {...storyblokEditable(blok)}>
      <GridLayout.Content width="1/3" align="center">
        <CheckoutContentPlaceholder />
      </GridLayout.Content>

      <GridLayout.Content width="1" align="center">
        {blok.checkoutPageContent.map((nestedBlock) => (
          <StoryblokComponent key={nestedBlock._uid} blok={nestedBlock} />
        ))}
      </GridLayout.Content>
    </GridLayout.Root>
  )
}

function CheckoutContentPlaceholder() {
  return (
    <div className={yStack({ gap: 'xxxl' })} style={{ marginTop: '1rem' }}>
      {/* Breadcrumb steps */}
      <div className={xStack({ gap: 'md' })}>
        <Skeleton style={{ flex: 1, height: '2.125rem' }} />
        <Skeleton style={{ flex: 1, height: '2.125rem' }} />
        <Skeleton style={{ flex: 1, height: '2.125rem' }} />
      </div>

      {/* Heading */}
      <Skeleton style={{ height: '5.625rem' }} />

      <div className={yStack({ gap: 'md' })}>
        <div className={yStack({ gap: 'xl' })}>
          <ProductItemSkeleton />
          <Skeleton style={{ height: '16rem' }} />
        </div>

        <Skeleton style={{ height: '3.5rem' }} />
      </div>
    </div>
  )
}
